import { combineReducers } from "redux";

// instructor reducers
import {
  instructorCoursesMapReducer as instructorCoursesMap,
  instructorImportCoursesListReducer as instructorImportCoursesList,
  instructorInstituteListReducer as instituteList,
  instructorDepartmentListReducer as departmentList,
  fileUploadProgressReducer as fileUploadProgress,
} from "Store/MyDashboard/Instructor/Reducer.js";
import instructorCourseGC from "Store/Course/Instructor/Reducer.js";
import userCourseRoleReducer, { courseApprovalStatusReducer } from "Store/Course/MultipleRoles/Reducer.js";
import instructorConceptDataMap from "Reducers/Instructor/instructorConceptDataReducer.js";

// student reducers
import studentCoursesMap from "Reducers/Student/studentCoursesListReducer.js";
import {
  publicCoursesReducer as publicCoursesMap,
  paginationInfoReducer as paginationInfo,
} from "Reducers/Common/publicCoursesReducer";
// import paginationInfoReducer from 'Reducers/Common/publicCoursesReducer'
import studentCourseGroupsMap from 'Reducers/Student/studentCourseGroupsReducer';
import studentGroupConceptsMap from 'Reducers/Student/studentGroupConceptsReducer';
import studentConceptDataMap from 'Reducers/Student/studentConceptDataReducer';
import studentprogramming from 'Store/Programming/Student/Reducer';
import instructorProgramming from 'Store/Programming/Instructor/Reducer';
import issues from 'Store/Issues/Reducer';

// commonReducer
import { userAuthReducer as userInfo } from "Store/UserInfo/Reducer";
import scheduleList from "Reducers/Common/scheduleListReducer";

// OtherLabs
import { OtherLabsReducer as otherLabs } from "Store/Course/Instructor/OtherLabs/Reducer";

// Labs
import { LabsReducer as labs} from 'Store/Course/Instructor/Labs/Reducer';

import { connectRouter } from "connected-react-router";

// import { createBrowserHistory } from "history";
import { forumReducer as forum } from "Store/Forum/Reducer";
import { studentGrades } from "../Store/Grades/Student/grades";
import analyticsReducer from "Store/Analytics/Reducer";
// export const history = createBrowserHistory();
import { enableMapSet } from "immer";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import ChatbotReducer from "./Chatbot/Reducer";


//import notes reducer
import notesReducer from "Store/Notes/Reducer.js";


enableMapSet();

const userInfoKey = (
  function generateUniqueKeyPrefixToAvoidSharingDataBetweenDifferentSubdomains() {
    return window.location.host+'UserInfo'
  }
)();

const persistConfig = {
  key: userInfoKey,
  storage: storage,
  blacklist: ['error', 'msg']
}

const rootReducer = (history) =>
  combineReducers({
    notes: notesReducer, // Add the notes reducer to the root reducer
    router: connectRouter(history),
    instructorCoursesMap,
    instructorImportCoursesList,
    publicCoursesMap,
    instituteList,
    departmentList,
    fileUploadProgress,
    paginationInfo,
    instructorCourseGC,
    instructorConceptDataMap,

    studentCoursesMap,
    studentCourseGroupsMap,
    studentGroupConceptsMap,
    studentConceptDataMap,
    studentprogramming,
    instructorProgramming,
    issues,
    forum,
    studentGrades,
    // common
    userInfo: persistReducer(persistConfig, userInfo),
    scheduleList,
    otherLabs,
    labs,
    // multiple roles
    userCourseRole: userCourseRoleReducer,
    // Course approval status persists across component remounts to prevent tab flickering
    courseApprovalStatus: courseApprovalStatusReducer,
    // analytics
    analytics: analyticsReducer,
    chatbot: ChatbotReducer,
  });

export default rootReducer;
